import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Login from './Component/Login/Login.js';
import Signup from './Component/SignUp/SignUp.js';
import MainRoutes from './Component/Dashboard/routes';

function App() {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isSignupMode, setIsSignupMode] = useState(false);

  // Load from localStorage on initial load
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedLogin = localStorage.getItem('isLoggedIn');

    if (storedUser && storedLogin === 'true') {
      setUser(JSON.parse(storedUser));
      setIsLoggedIn(true);
    }
  }, []);

  const handleSignup = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('isLoggedIn', 'false'); // signup done but not logged in
    setIsSignupMode(false);
    alert('Signup successful. You can now log in.');
  };

  const handleLogin = (userData) => {
    setUser(userData);
    setIsLoggedIn(true);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('isLoggedIn', 'true');
  };

  const handleLogout = () => {
    setUser(null);
    setIsLoggedIn(false);
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
  };

  if (isLoggedIn && user) {
    return (
      <BrowserRouter>
        <MainRoutes user={user} />
      </BrowserRouter>
    );
  }

  return isSignupMode ? (
    <Signup onSignup={handleSignup} onToggleToLogin={() => setIsSignupMode(false)} />
  ) : (
    <Login
      onLogin={handleLogin}
      registeredUser={user}
      onToggleToSignup={() => setIsSignupMode(true)}
    />
  );
}

export default App;
